import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

const Props = {
  children: PropTypes.node.isRequired,
};

export default function GalleryGrid({ children }) {
  return <Container>{children}</Container>;
}

GalleryGrid.propTypes = Props;
